import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function passwordShowHide(props : {passwordShow : boolean, setPasswordShow : (newPasswordShow : boolean) =>void}){
    
    return <span onClick={()=> props.setPasswordShow(!props.passwordShow)}> 
        {props.passwordShow ? <FontAwesomeIcon icon="eye"/> : <FontAwesomeIcon icon="eye-slash"/>}
    </span> 
}